module.exports = __webpack_public_path__ + "img/approval.24153669.jpeg";